import axios from "axios";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { roleId } from "../Constants/app";
import Select from "react-select";
import { selectCityRM, selectMonthRM, setActiveComponent } from "../../Reducer/RevenueModuleSlice";


function MainMenuEnteringData() {
    const User = useSelector(state => state.UserSlice.User);
    const Server = useSelector(state => state.UserSlice.Server);
    const SelectedCity = useSelector(state => state.RevenueModuleSlice.selectedCity);
    const SelectedMonth = useSelector(state => state.RevenueModuleSlice.selectedMonth);

    const [ loading, setLoading ] = useState(true);
    const [ cities, setCities ] = useState([]);
    const [ months, setMonths ] = useState([]);

    const dispatch = useDispatch();

    const renderAdress = (item) => {
        return item.City + ' ' + item.Adress;
    }

    const handleChangePoint = (value) => {
        dispatch(selectCityRM(value));
    }

    const handleChangeMonth = (value) => {
        dispatch(selectMonthRM(value));
    }

    const isValid = () => {
        if (!SelectedCity || SelectedCity.id === 0) return false;
        if (!SelectedMonth || SelectedMonth.id === 0) return false;
        return true;
    }

    const handleClickNext = () => {
        if (isValid()) {
            return dispatch(setActiveComponent('enteringData'))
        } else {
            return alert('Не указаны данные')
        }
    }

    const getCity = async () =>  {
        setLoading(false)
        var CityArrayChecked = []
        var CityCheck 
        await axios.get(Server + 'cities?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            if([roleId.admin, roleId.operatingDirector].includes(User.user.role.id) || User.user.idCity === 'all')
            {
                setLoading(response.data);
                setCities(response.data);
            }
            else
            {
                CityCheck = response.data
            }
        })

        if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && User.user.idCity !== 'all')
        {
            await User.user.idCity.map((el) => {
                CityCheck.map((a) => {
                    if(parseInt(a.id) === parseInt(el))
                    {
                        CityArrayChecked.push(a)
                    }
                    return(a)
                })
                return(el)
            })
            await setLoading(CityArrayChecked)
            await setCities(CityArrayChecked)
        }
  
        await axios.get(Server + 'months?_limit=-1&_sort=id:DESC', {
            headers: {
                Authorization:'Bearer ' + User.jwt,
            }
        })
        .then((responseMonth) => {
            setMonths(responseMonth.data)
            setMonths(responseMonth.data)
        })
        
        setLoading(true)
    }

    useState(() => {
        getCity();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleClickBack = () => {
        dispatch(setActiveComponent(null));
    }

    if (!loading) return(
        <div className="ModalGlobalDiv" >
            <div className="BigSpin" />
        </div>
    )

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="MainMenuMainDiv"
            >
                <div
                className="MainMenuDataDiv"
                >
                    <div
                    className="MainMenuColumnDiv"
                    >
                        
                        <div className="DivFlex Gap" style={{ alignItems: 'center' }} >
                            <div style={{ width: '210px' }}>
                                <Select
                                closeMenuOnSelect={true}
                                options={cities
                                    .sort((a, b) => {
                                    const adressA = renderAdress(a);
                                    const adressB = renderAdress(b);
                                    if (adressA < adressB) return -1;
                                    if (adressA > adressB) return 1;
                                    return 0;
                                    })
                                    .map(item => ({
                                        value: item,
                                        label: renderAdress(item)
                                    }))}
                                onChange={((e) => handleChangePoint(e.value))}
                                placeholder="Филиал"
                                noOptionsMessage={() => 'Нет филиалов'}
                                value={SelectedCity && SelectedCity.id > 0 ? {value: SelectedCity, label: renderAdress(SelectedCity)} : null}
                                />
                            </div>
                        </div>
                        
                        
                        <div>
                            <div className="DivFlex Gap" style={{ alignItems: 'center' }}>
                                <div style={{ width: '210px' }}>
                                    <Select
                                    closeMenuOnSelect={true}
                                    options={months
                                        .map(item => ({
                                            value: item,
                                            label: item.Name
                                        }))}
                                    onChange={((e) => handleChangeMonth(e.value))}
                                    placeholder="Месяц"
                                    noOptionsMessage={() => 'Нет месяцев'}
                                    value={SelectedMonth && SelectedMonth.id > 0 ? {value: SelectedMonth, label: SelectedMonth.Name} : null}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <button
                        className="ButtonMainMenu"
                        onClick={handleClickNext}
                        >
                            Далее
                        </button>
                        {User.user.role.id !== roleId.cashier && <button className="ButtonMainMenu" style={{ backgroundColor: '#f7f7f7', outline: '1px solid rgba(0, 0, 0, 0.308)', color: 'black' }} onClick={handleClickBack} >
                            Назад
                        </button>}
                    </div>
                </div>
            
            </div>
        </div>
    )
}

export default MainMenuEnteringData;